import talkPsikolog from "../images/talkPsikolog.webp";
import konsultasiImage from "../images/konsultasi.webp";
import childrenschoolImage from "../images/childrenschools.webp";
import minatBakatImage from "../images/minatbakat.webp";
import deteksiMasalahAkademikImage from "../images/deteksiakademik.webp";
import tumbuhKembangImage from "../images/tumbuhkembang.webp";
import tesKecerdasanImage from "../images/kecerdasan.webp";
import recruitmentImage from "../images/rectruitmentimage.webp";
import psikoedukasiImage from "../images/psikoedukasi.webp";
import konsultasianakimage from "../images/konsultasi_anak_img.webp";
import parentingImage from "../images/parentingclass.webp";
import sharingClassImage from "../images/sharingclass.webp";
import iqtestImage from "../images/iqtes.webp";
import childConsultation from "../images/childconsultation.webp";
import montessoriImage from "../images/montessori.webp";
import sensorikImage from "../images/sensorik.webp";
import tesKepribadianImage from "../images/tesKepribadianImage.webp";
import tesMinatBakatImage from "../images/tesMinatBakatImage.webp";
import interviewImage from "../images/interview.webp";

const layanans = [
  {
    slug: "konsultasi",
    title: "Konsultasi",
    category: "Konsultasi",
    subtitle:
      "Layanan konsultasi psikologis untuk berbagai masalah pribadi dan emosional",
    description:
      "Layanan konsultasi ini membantu individu mengatasi berbagai masalah pribadi dan emosional, seperti kecemasan, depresi, stres, dan masalah hubungan. Psikolog akan bekerja sama dengan Anda untuk menemukan solusi yang tepat.",
    image: konsultasiImage,
    bgColor: "#7FDCF9",
    activity_description:
      "Kegiatan ini melibatkan penilaian dan intervensi psikologis yang dirancang untuk membantu individu mengatasi berbagai masalah pribadi dan emosional.",
    activity: [
      {
        title: "Sesi Konseling Individu",
        description:
          "Sesi tatap muka dengan psikolog untuk membahas dan mengatasi masalah pribadi dan emosional.",
        image: recruitmentImage,
        bgColor: "#7FDCF9",
      },
      {
        title: "Terapi Kognitif Perilaku",
        description:
          "Pendekatan terapi yang fokus pada mengubah pola pikir negatif dan perilaku maladaptif.",
        image: konsultasiImage,
        bgColor: "#FFA2C9 ",
      },
      {
        title: "Pelatihan Manajemen Stres",
        description:
          "Teknik dan strategi untuk mengelola stres secara efektif dan meningkatkan kesejahteraan emosional.",
        image: minatBakatImage,
        bgColor: "#9BE2D0",
      },
    ],
    benefit_image: deteksiMasalahAkademikImage,
    benefits: [
      {
        title: "Pemahaman Diri yang Lebih Baik",
        description:
          "Membantu individu mendapatkan wawasan tentang masalah mereka dan menemukan solusi yang efektif.",
      },
      {
        title: "Peningkatan Kesejahteraan Emosional",
        description:
          "Mengurangi gejala kecemasan, depresi, dan stres melalui intervensi yang sesuai.",
      },
      {
        title: "Keterampilan Menghadapi Masalah",
        description:
          "Mengajarkan keterampilan yang berguna untuk mengatasi tantangan hidup dan meningkatkan kualitas hidup.",
      },
      {
        title: "Pengembangan Kemampuan Coping",
        description:
          "Meningkatkan kemampuan dalam menghadapi dan mengelola situasi stres atau emosional.",
      },
      {
        title: "Peningkatan Kualitas Hidup",
        description:
          "Memperbaiki keseimbangan emosional dan kesejahteraan mental yang berkontribusi pada kehidupan yang lebih berkualitas.",
      },
      {
        title: "Pemberdayaan Diri",
        description:
          "Mendorong kemandirian dan penguatan diri dalam menghadapi berbagai tantangan hidup.",
      },
    ],
  },
  {
    slug: "konsultasi-anak",
    title: "Konsultasi Anak",
    category: "Konsultasi",
    subtitle: "Layanan konsultasi untuk membantu perkembangan psikologis anak",
    description:
      "Konsultasi Anak adalah layanan yang dirancang untuk membantu anak-anak mengatasi berbagai masalah psikologis dan emosional yang mereka hadapi. Layanan ini mencakup evaluasi, diagnosis, dan intervensi yang disesuaikan dengan kebutuhan masing-masing anak.",
    image: childConsultation,
    bgColor: "#7FDCF9",
    activity_description:
      "Layanan ini melibatkan berbagai aktivitas untuk mendukung perkembangan psikologis anak.",
    activity: [
      {
        title: "Diagnosis Psikologis",
        description:
          "Evaluasi untuk mengidentifikasi masalah psikologis dan emosional yang mungkin dialami anak.",
        image: deteksiMasalahAkademikImage,
        bgColor: "#7FDCF9",
      },
      {
        title: "Intervensi dan Terapi",
        description:
          "Program terapi yang dirancang untuk meningkatkan keterampilan dan menangani masalah emosional anak secara efektif.",
        image: minatBakatImage,
        bgColor: "#9BE2D0",
      },
      {
        title: "Evaluasi Psikologis",
        description:
          "Penilaian menyeluruh untuk memahami kondisi psikologis anak, termasuk aspek emosional dan perilaku, serta mengidentifikasi kebutuhan intervensi.",
        image: konsultasiImage,
        bgColor: "#FFA2C9",
      },
    ],
    benefit_image: talkPsikolog,
    benefits: [
      {
        title: "Pendekatan Personal",
        description:
          "Pendekatan yang disesuaikan dengan kebutuhan unik setiap anak untuk intervensi yang lebih efektif.",
      },
      {
        title: "Pengembangan Keterampilan Sosial dan Emosional",
        description:
          "Membantu anak mengembangkan keterampilan sosial dan emosional yang penting untuk kehidupan sehari-hari.",
      },
      {
        title: "Dukungan untuk Orang Tua",
        description:
          "Memberikan panduan dan dukungan kepada orang tua untuk memahami dan membantu anak mereka dengan lebih baik.",
      },
      {
        title: "Peningkatan Kesejahteraan Emosional",
        description:
          "Meningkatkan kesejahteraan emosional anak dengan mengatasi masalah yang mengganggu perkembangan mereka.",
      },
      {
        title: "Monitoring dan Evaluasi Berkala",
        description:
          "Melakukan monitoring dan evaluasi berkala untuk menilai kemajuan dan efektivitas intervensi yang diterapkan.",
      },
      {
        title: "Pemantauan Kemajuan Individual",
        description:
          "Melakukan pemantauan individu untuk melacak kemajuan dan menyesuaikan strategi intervensi sesuai kebutuhan anak.",
      },
    ],
  },
  {
    slug: "tes-kecerdasan",
    title: "Tes Kecerdasan (IQ)",
    category: "Psikotes",
    subtitle: "Penilaian tingkat kecerdasan anak secara komprehensif",
    description:
      "Tes kecerdasan bertujuan untuk menilai kemampuan kognitif anak secara menyeluruh, termasuk pemahaman verbal, logika, dan kemampuan pemecahan masalah. Hasil tes ini dapat membantu dalam menentukan kebutuhan pendidikan anak.",
    image: iqtestImage,
    bgColor: "#FFC36C",
    activity_description:
      "Aktivitas dalam tes kecerdasan ini dirancang untuk menilai berbagai aspek kognitif dan kemampuan anak.",
    activity: [
      {
        title: "Penilaian Kognitif Umum",
        description:
          "Evaluasi kemampuan berpikir logis, pemecahan masalah, dan keterampilan kognitif dasar anak secara menyeluruh.",
        image: childrenschoolImage,
        bgColor: "#FFA2C9",
      },
      {
        title: "Kemampuan Verbal",
        description:
          "Menilai pemahaman bahasa, keterampilan berbicara, dan kemampuan komunikasi verbal anak.",
        image: minatBakatImage,
        bgColor: "#9BE2D0 ",
      },
      {
        title: "Kemampuan Performansi",
        description:
          "Mengukur kemampuan anak dalam menyelesaikan tugas-tugas yang memerlukan keterampilan praktis dan pemecahan masalah secara visual dan motorik.",
        image: talkPsikolog,
        bgColor: "#7FDCF9",
      },
    ],
    benefit_image: deteksiMasalahAkademikImage,
    benefits: [
      {
        title: "Pemahaman Mendalam tentang Kemampuan Anak",
        description:
          "Memberikan wawasan yang mendalam tentang kekuatan dan kelemahan kognitif anak untuk mendukung pengembangan yang lebih baik.",
      },
      {
        title: "Peningkatan Metode Pengajaran",
        description:
          "Membantu guru dan orang tua dalam menyesuaikan metode pengajaran agar sesuai dengan kemampuan kognitif dan gaya belajar anak.",
      },
      {
        title: "Perencanaan Pendidikan yang Tepat",
        description:
          "Membantu dalam merencanakan strategi pendidikan yang tepat berdasarkan hasil tes untuk memaksimalkan potensi anak.",
      },
      {
        title: "Identifikasi Potensi Masalah Belajar",
        description:
          "Mendeteksi potensi masalah belajar yang mungkin memerlukan intervensi tambahan.",
      },
      {
        title: "Pengembangan Keterampilan Kognitif",
        description:
          "Menyediakan dasar untuk merancang program pengembangan keterampilan kognitif anak yang spesifik.",
      },
      {
        title: "Evaluasi Kemajuan Akademik",
        description:
          "Menilai kemajuan akademik anak dari waktu ke waktu untuk menyesuaikan dukungan dan strategi pendidikan.",
      },
    ],
  },
  {
    slug: "tes-kesiapan-sekolah",
    title: "Tes Kesiapan Sekolah",
    category: "Psikotes",
    subtitle: "Evaluasi kesiapan anak untuk memasuki pendidikan formal",
    description:
      "Tes kesiapan sekolah dirancang untuk menilai apakah anak siap secara kognitif, sosial, emosional, fisik, kemandirian dan bahasa untuk memulai pendidikan formal. Evaluasi ini membantu orang tua dan guru memahami kebutuhan dan potensi anak.",
    image: childrenschoolImage,
    bgColor: "#FFC36C",
    activity_description:
      "Kegiatan ini mencakup berbagai penilaian seperti kognitif, sosial, emosional, fisik, kemandirian, dan bahasa. Setiap aspek dievaluasi untuk mendapatkan gambaran menyeluruh tentang kesiapan anak dalam memasuki pendidikan formal.",
    activity: [
      {
        title: "Penilaian Kognitif",
        description:
          "Evaluasi kemampuan berpikir, pemecahan masalah, dan keterampilan belajar dasar.",
        image: talkPsikolog,
        bgColor: "#9BE2D0",
      },
      {
        title: "Penilaian Sosial",
        description:
          "Observasi interaksi anak dengan teman sebaya dan kemampuan beradaptasi dalam lingkungan sosial.",
        image: deteksiMasalahAkademikImage,
        bgColor: "#7FDCF9",
      },
      {
        title: "Penilaian Emosional",
        description:
          "Mengidentifikasi regulasi emosi, kematangan emosional, dan respons terhadap situasi yang menantang.",
        image: konsultasiImage,
        bgColor: "#FFA2C9",
      },
      {
        title: "Kegiatan Fisik",
        description:
          "Mengukur keterampilan motorik kasar melalui aktivitas fisik seperti berjalan, berlari, dan melompat.",
        image: montessoriImage,
        bgColor: "#FFDD83",
      },
      {
        title: "Kemandirian",
        description:
          "Menilai kemampuan anak dalam melakukan tugas-tugas sehari-hari secara mandiri, seperti berpakaian dan merapikan barang.",
        image: tesMinatBakatImage,
        bgColor: "#ECECEC",
      },
      {
        title: "Bahasa",
        description:
          "Evaluasi kemampuan bahasa, termasuk pemahaman, ekspresi verbal, dan keterampilan komunikasi.",
        image: tesKecerdasanImage,
        bgColor: "#C4B0FF",
      },
    ],
    benefit_image: tesMinatBakatImage,
    benefits: [
      {
        title: "Persiapan Optimal",
        description:
          "Membantu memastikan anak siap menghadapi tantangan pendidikan formal dengan memberikan gambaran mengenai area yang mungkin memerlukan dukungan lebih lanjut.",
      },
      {
        title: "Identifikasi Kebutuhan",
        description:
          "Menyediakan informasi yang berguna untuk menyesuaikan pendekatan pengajaran dan dukungan sesuai dengan kebutuhan spesifik anak.",
      },
      {
        title: "Perencanaan Pendidikan",
        description:
          "Memudahkan orang tua dan guru dalam merancang strategi yang efektif untuk mendukung perkembangan anak selama masa transisi ke sekolah.",
      },
      {
        title: "Pengembangan Keterampilan Sosial",
        description:
          "Membantu anak dalam mengembangkan keterampilan sosial yang diperlukan untuk berinteraksi dengan teman sebaya dan orang dewasa di lingkungan sekolah.",
      },
      {
        title: "Meningkatkan Kepercayaan Diri",
        description:
          "Dengan penilaian yang komprehensif, anak akan mendapatkan dukungan yang sesuai, yang dapat meningkatkan kepercayaan diri mereka saat memasuki sekolah.",
      },
      {
        title: "Pemantauan Perkembangan",
        description:
          "Memberikan dasar untuk pemantauan jangka panjang terhadap perkembangan anak dan penyesuaian intervensi yang diperlukan.",
      },
    ],
  },

  {
    slug: "tes-minat-bakat",
    title: "Tes Minat Bakat",
    category: "Psikotes",
    subtitle: "Penilaian untuk mengidentifikasi minat dan bakat anak",
    description:
      "Tes ini bertujuan untuk mengidentifikasi minat dan bakat anak, membantu mereka dalam memilih jalur pendidikan dan karir yang sesuai dengan potensi mereka.",
    image: tesMinatBakatImage,
    bgColor: "#FFC36C",
    activity_description:
      "Tes ini melibatkan berbagai jenis penilaian untuk menilai minat dan bakat anak.",
    activity: [
      {
        title: "Penilaian Minat",
        description:
          "Mengidentifikasi minat anak melalui berbagai kuisioner dan tes.",
        image: konsultasianakimage,
        bgColor: "#7FDCF9 ",
      },
      {
        title: "Penilaian Bakat",
        description:
          "Menilai bakat anak dalam berbagai bidang seperti seni, olahraga, dan akademik.",
        image: tesKecerdasanImage,
        bgColor: "#FFA2C9",
      },
      {
        title: "Pemetaan Potensi",
        description:
          "Menggabungkan hasil dari penilaian minat dan bakat untuk memberikan gambaran menyeluruh tentang potensi anak.",
        image: talkPsikolog,
        bgColor: "#9BE2D0",
      },
    ],
    benefit_image: childrenschoolImage,
    benefits: [
      {
        title: "Pemetaan Karir",
        description:
          "Memberikan panduan untuk memilih jalur pendidikan dan karir yang sesuai dengan minat dan bakat anak.",
      },
      {
        title: "Peningkatan Kepercayaan Diri",
        description:
          "Membantu anak merasa lebih yakin dengan potensi dan kemampuan mereka.",
      },
      {
        title: "Perencanaan Pendidikan",
        description:
          "Membantu orang tua dan pendidik merencanakan pendidikan yang sesuai dengan minat dan bakat anak.",
      },
      {
        title: "Identifikasi Kelebihan dan Kekurangan",
        description:
          "Menyoroti area di mana anak memiliki kelebihan dan area yang perlu dikembangkan lebih lanjut.",
      },
      {
        title: "Pengembangan Potensi",
        description:
          "Memberikan wawasan tentang cara mengembangkan potensi yang ada berdasarkan hasil penilaian.",
      },
      {
        title: "Fokus pada Kekuatan Individu",
        description:
          "Membantu anak dan keluarga fokus pada kekuatan dan minat utama yang dapat meningkatkan pencapaian akademik dan karir.",
      },
    ],
  },
  {
    slug: "tes-kepribadian",
    title: "Tes Kepribadian",
    category: "Psikotes",
    subtitle: "Analisis mendalam tentang karakter dan preferensi individu",
    description:
      "Tes kepribadian bertujuan untuk mengungkap aspek-aspek utama dari karakter, preferensi, dan gaya interaksi seseorang. Hasil tes ini dapat membantu dalam memahami diri sendiri dan meningkatkan interaksi sosial serta pengembangan pribadi.",
    image: tesKepribadianImage,
    bgColor: "#FFC36C",
    activity_description:
      "Tes ini mencakup berbagai penilaian untuk mengidentifikasi karakteristik kepribadian dan preferensi individu.",
    activity: [
      {
        title: "Penilaian Kepribadian",
        description:
          "Evaluasi aspek-aspek kepribadian utama seperti kecenderungan emosional, gaya berpikir, dan preferensi sosial.",
        image: minatBakatImage,
        bgColor: "#9BE2D0",
      },
      {
        title: "Analisis Gaya Berpikir",
        description:
          "Menganalisis bagaimana seseorang memproses informasi dan mengambil keputusan.",
        image: tesKecerdasanImage,
        bgColor: "#FFA2C9",
      },
      {
        title: "Evaluasi Preferensi Sosial",
        description:
          "Menilai kecenderungan sosial seseorang, seperti introversi dan ekstroversi, serta preferensi interaksi dengan orang lain.",
        image: talkPsikolog,
        bgColor: "#7FDCF9",
      },
    ],
    benefit_image: deteksiMasalahAkademikImage,
    benefits: [
      {
        title: "Pemahaman Diri",
        description:
          "Memberikan wawasan yang lebih dalam tentang karakteristik dan preferensi kepribadian untuk pengembangan diri yang lebih baik.",
      },
      {
        title: "Peningkatan Interaksi Sosial",
        description:
          "Membantu dalam memahami bagaimana berinteraksi dengan orang lain secara lebih efektif berdasarkan gaya kepribadian.",
      },
      {
        title: "Strategi Pengembangan Pribadi",
        description:
          "Menyediakan rencana pengembangan yang disesuaikan dengan karakteristik kepribadian individu.",
      },
      {
        title: "Optimalisasi Potensi Diri",
        description:
          "Membantu mengidentifikasi dan memaksimalkan potensi diri berdasarkan kekuatan kepribadian yang dimiliki.",
      },
      {
        title: "Pengelolaan Emosi",
        description:
          "Membantu individu memahami dan mengelola emosinya dengan lebih baik berdasarkan kecenderungan kepribadian.",
      },
      {
        title: "Perbaikan Hubungan Interpersonal",
        description:
          "Membantu individu memahami cara memperbaiki dan meningkatkan kualitas hubungan interpersonal berdasarkan preferensi sosial dan gaya interaksi.",
      },
    ],
  },
  {
    slug: "screening-tumbuh-kembang",
    title: "Screening Tumbuh Kembang",
    category: "Psikotes",
    subtitle: "Pemeriksaan perkembangan anak secara menyeluruh",
    description:
      "Screening tumbuh kembang adalah proses pemeriksaan yang dilakukan untuk menilai perkembangan fisik, kognitif, sosial, dan emosional anak, serta mengidentifikasi adanya keterlambatan atau masalah perkembangan.",
    image: tumbuhKembangImage,
    bgColor: "#FFC36C",
    activity_description:
      "Screening ini melibatkan penilaian menyeluruh terhadap berbagai aspek perkembangan anak.",
    activity: [
      {
        title: "Penilaian Fisik dan Bahasa",
        description:
          "Evaluasi keterampilan motorik kasar, halus, serta kemampuan bahasa dan komunikasi anak untuk memahami perkembangan fisik dan linguistik mereka.",
        image: konsultasianakimage,
        bgColor: "#7FDCF9",
      },
      {
        title: "Penilaian Kognitif",
        description:
          "Menilai perkembangan kognitif dan keterampilan belajar anak.",
        image: tesKecerdasanImage,
        bgColor: "#FFA2C9",
      },
      {
        title: "Penilaian Sosial dan Emosional",
        description:
          "Menilai kemampuan sosial dan emosional anak serta mengidentifikasi potensi masalah.",
        image: childrenschoolImage,
        bgColor: "#C4B0FF",
      },
    ],
    benefit_image: recruitmentImage,
    benefits: [
      {
        title: "Deteksi Dini",
        description:
          "Mengidentifikasi masalah perkembangan sejak dini untuk intervensi yang lebih cepat.",
      },
      {
        title: "Gambaran Menyeluruh",
        description:
          "Memberikan gambaran menyeluruh tentang perkembangan anak di berbagai aspek.",
      },
      {
        title: "Pemantauan Berkala",
        description:
          "Memungkinkan pemantauan perkembangan anak dari waktu ke waktu untuk memastikan kemajuan dan adaptasi intervensi yang diperlukan.",
      },
      {
        title: "Dukungan Pengembangan",
        description:
          "Membantu orang tua dan pendidik dalam merencanakan dukungan yang sesuai untuk perkembangan anak.",
      },
      {
        title: "Pengenalan Potensi Keterlambatan",
        description:
          "Mendeteksi potensi keterlambatan atau masalah perkembangan untuk segera mengadakan intervensi yang sesuai.",
      },
      {
        title: "Perencanaan Individual",
        description:
          "Menyediakan informasi untuk merancang rencana pengembangan yang disesuaikan dengan kebutuhan spesifik anak.",
      },
    ],
  },

  {
    slug: "program-terapi-anak-berkebutuhan-khusus",
    title: "Program Terapi Anak Berkebutuhan Khusus",
    category: "Self Growth",
    subtitle: "Terapi untuk anak dengan kebutuhan khusus",
    description:
      "Program terapi ini dirancang khusus untuk anak-anak dengan kebutuhan khusus, seperti autism, ADHD, dan gangguan perkembangan lainnya. Terapi ini membantu anak mencapai potensi maksimal mereka melalui pendekatan yang individual.",
    image: talkPsikolog,
    bgColor: "#FFA2C9",
    activity_description:
      "Program ini melibatkan berbagai terapi dan penilaian untuk mendukung perkembangan anak.",
    activity: [
      {
        title: "Sensory Integration Therapy",
        description:
          "Terapi yang bertujuan untuk membantu anak mengatur dan memproses rangsangan sensorik, sehingga mereka dapat merespons lingkungan dengan cara yang lebih adaptif.",
        image: tesKecerdasanImage,
        bgColor: "#FFA2C9",
      },
      {
        title: "Behavioral Therapy",
        description:
          "Terapi perilaku yang fokus pada pengubahan perilaku maladaptif dan penguatan perilaku positif melalui pendekatan terstruktur.",
        image: childrenschoolImage,
        bgColor: "#9BE2D0 ",
      },
      {
        title: "Speech and Language Therapy",
        description:
          "Terapi yang membantu anak dalam mengembangkan keterampilan komunikasi, baik verbal maupun nonverbal, untuk meningkatkan interaksi sosial dan kemampuan berbahasa.",
        image: talkPsikolog,
        bgColor: "#7FDCF9",
      },
    ],
    benefit_image: konsultasianakimage,
    benefits: [
      {
        title: "Pendekatan Individual",
        description:
          "Memberikan terapi yang disesuaikan dengan kebutuhan khusus masing-masing anak.",
      },
      {
        title: "Peningkatan Kemampuan Motorik",
        description:
          "Membantu anak mengembangkan keterampilan motorik dan koordinasi melalui terapi integrasi sensorik.",
      },
      {
        title: "Pengelolaan Perilaku",
        description:
          "Meningkatkan kemampuan anak untuk mengatur perilaku mereka melalui terapi perilaku yang terstruktur.",
      },
      {
        title: "Regulasi Emosi yang Lebih Baik",
        description:
          "Membantu anak belajar mengelola dan mengatur emosi mereka, sehingga meningkatkan kemampuan mereka untuk menghadapi situasi yang menantang.",
      },
      {
        title: "Pengembangan Keterampilan Komunikasi",
        description:
          "Memperbaiki keterampilan komunikasi anak melalui terapi bahasa dan bicara, mendukung interaksi sosial yang lebih baik.",
      },
      {
        title: "Peningkatan Kemandirian",
        description:
          "Mendorong anak untuk mengembangkan kemandirian dalam melakukan tugas-tugas sehari-hari melalui berbagai aktivitas terapi yang dirancang.",
      },
    ],
  },
  {
    slug: "play-therapy-program",
    title: "Play Therapy Program",
    category: "Self Growth",
    subtitle:
      "Terapi bermain untuk mendukung perkembangan emosional dan sosial anak",
    description:
      "Play Therapy Program dirancang untuk membantu anak-anak mengekspresikan diri, mengatasi emosi, dan mengembangkan keterampilan sosial melalui aktivitas bermain yang terarah. Program ini memberikan ruang yang aman bagi anak untuk mengungkapkan perasaan dan dunia imajinasinya, serta belajar mengatasi berbagai masalah emosional dan perilaku.",
    image: tesKecerdasanImage,
    bgColor: "#FFA2C9",
    activity_description:
      "Aktivitas dalam Play Therapy Program melibatkan berbagai jenis permainan yang dirancang untuk mendukung perkembangan emosional dan sosial anak.",
    activity: [
      {
        title: "Permainan Simbolis",
        description:
          "Menggunakan permainan simbolis untuk membantu anak mengekspresikan emosi dan mengatasi masalah emosional secara kreatif.",
        image: talkPsikolog,
        bgColor: "#7FDCF9",
      },
      {
        title: "Permainan Kreatif",
        description:
          "Aktivitas kreatif seperti menggambar atau bermain dengan tanah liat untuk mendukung ekspresi diri dan pengelolaan emosi anak.",
        image: minatBakatImage,
        bgColor: "#9BE2D0",
      },
      {
        title: "Permainan Sosial",
        description:
          "Permainan yang melibatkan interaksi sosial untuk membantu anak mengembangkan keterampilan sosial dan kemampuan bekerja sama.",
        image: childrenschoolImage,
        bgColor: "#FFA2C9",
      },
    ],
    benefit_image: deteksiMasalahAkademikImage,
    benefits: [
      {
        title: "Ekspresi Emosi yang Sehat",
        description:
          "Membantu anak mengekspresikan emosi mereka secara sehat melalui berbagai aktivitas bermain.",
      },
      {
        title: "Pengembangan Keterampilan Sosial",
        description:
          "Meningkatkan kemampuan anak dalam berinteraksi dengan orang lain dan mengembangkan keterampilan sosial yang penting.",
      },
      {
        title: "Peningkatan Kepercayaan Diri",
        description:
          "Meningkatkan kepercayaan diri anak melalui pencapaian dalam aktivitas bermain yang dirancang.",
      },
      {
        title: "Pengurangan Stres dan Kecemasan",
        description:
          "Membantu anak mengurangi stres dan kecemasan melalui medium bermain yang menyenangkan dan terapeutik.",
      },
      {
        title: "Peningkatan Kesejahteraan Emosional",
        description:
          "Mendukung kesejahteraan emosional anak dengan memberikan ruang untuk pemrosesan emosi dan pengembangan kesehatan mental.",
      },
      {
        title: "Perkembangan Kreativitas",
        description:
          "Mendorong anak untuk mengeksplorasi kreativitas mereka dan menemukan cara baru untuk mengekspresikan diri.",
      },
    ],
  },
  {
    slug: "montessori-program",
    title: "Montessori Program",
    category: "Self Growth",
    subtitle:
      "Pendekatan pendidikan berbasis Montessori untuk perkembangan anak",
    description:
      "Montessori Program adalah pendekatan pendidikan yang berfokus pada pembelajaran mandiri dan perkembangan anak sesuai dengan ritme mereka sendiri. Program ini dirancang untuk memfasilitasi eksplorasi, kreativitas, dan kemandirian anak melalui lingkungan yang terstruktur dan bahan ajar yang dirancang khusus.",
    image: montessoriImage,
    bgColor: "#FFA2C9",
    activity_description:
      "Program Montessori melibatkan berbagai aktivitas yang mendukung perkembangan kognitif, motorik, dan sosial anak dalam lingkungan yang aman dan mendukung.",
    activity: [
      {
        title: "Eksplorasi Mandiri",
        description:
          "Anak-anak diberikan kebebasan untuk memilih aktivitas yang sesuai dengan minat mereka, sehingga mendorong pembelajaran mandiri dan rasa tanggung jawab.",
        image: minatBakatImage,
        bgColor: "#9BE2D0",
      },
      {
        title: "Aktivitas Sensorik",
        description:
          "Kegiatan yang dirancang untuk mengembangkan keterampilan sensorik anak, seperti bahan-bahan tekstur dan permainan yang melibatkan indera mereka.",
        image: sensorikImage,
        bgColor: "#FFA2C9",
      },
      {
        title: "Pembelajaran Terstruktur",
        description:
          "Penggunaan bahan ajar Montessori yang dirancang untuk mendukung pembelajaran matematika, bahasa, dan keterampilan kehidupan sehari-hari dengan cara yang terstruktur dan menarik.",
        image: talkPsikolog,
        bgColor: "#7FDCF9",
      },
    ],
    benefit_image: tesKecerdasanImage,
    benefits: [
      {
        title: "Pengembangan Kemandirian",
        description:
          "Mendorong anak untuk menjadi mandiri dengan membuat pilihan sendiri dan menyelesaikan tugas secara independen.",
      },
      {
        title: "Kreativitas dan Ekspresi Diri",
        description:
          "Memberikan anak kesempatan untuk mengekspresikan diri dan kreativitas mereka melalui berbagai aktivitas yang dirancang.",
      },
      {
        title: "Peningkatan Keterampilan Sosial",
        description:
          "Mengembangkan keterampilan sosial anak melalui interaksi dengan teman sebaya dan kegiatan kelompok.",
      },
      {
        title: "Pembelajaran yang Disesuaikan",
        description:
          "Menyediakan pengalaman belajar yang sesuai dengan kebutuhan dan minat individu anak, memungkinkan mereka belajar dengan cara yang paling efektif bagi mereka.",
      },
      {
        title: "Lingkungan yang Aman dan Mendukung",
        description:
          "Menciptakan lingkungan yang aman dan mendukung di mana anak-anak merasa nyaman untuk bereksplorasi dan belajar.",
      },
      {
        title: "Pengembangan Kognitif dan Motorik",
        description:
          "Mendukung perkembangan kognitif dan motorik anak melalui bahan ajar yang dirancang khusus dan aktivitas yang melibatkan berbagai indera.",
      },
    ],
  },
  {
    slug: "psikoedukasi",
    title: "Psikoedukasi",
    category: "Workshops",
    subtitle:
      "Program edukasi psikologi untuk meningkatkan pemahaman masyarakat",
    description:
      "Program psikoedukasi bertujuan untuk meningkatkan pemahaman masyarakat tentang kesehatan mental dan pentingnya perawatan psikologis. Melalui sesi edukatif, peserta akan belajar tentang berbagai topik psikologi dan bagaimana menjaga kesehatan mental mereka.",
    image: psikoedukasiImage,
    bgColor: "#C4B0FF",
    activity_description:
      "Aktivitas dalam program psikoedukasi melibatkan penyampaian materi, diskusi, dan pelatihan untuk meningkatkan pemahaman tentang kesehatan mental.",
    activity: [
      {
        title: "Strategi Coping",
        description:
          "Pengenalan teknik-teknik coping untuk mengatasi stres dan masalah psikologis dalam kehidupan sehari-hari.",
        image: konsultasiImage,
        bgColor: "#FFA2C9",
      },
      {
        title: "Penyampaian Informasi",
        description:
          "Sesi edukasi yang memberikan informasi penting tentang kesehatan mental, gangguan psikologis, dan perawatan yang dapat dilakukan.",
        image: minatBakatImage,
        bgColor: "#9BE2D0",
      },
      {
        title: "Diskusi Interaktif",
        description:
          "Sesi diskusi yang memungkinkan peserta berbagi pengalaman dan bertanya tentang topik-topik terkait kesehatan mental dan psikologi.",
        image: tumbuhKembangImage,
        bgColor: "#7FDCF9",
      },
    ],
    benefit_image: recruitmentImage,
    benefits: [
      {
        title: "Peningkatan Pemahaman tentang Kesehatan Mental",
        description:
          "Memberikan pengetahuan yang lebih baik tentang kesehatan mental dan cara-cara untuk menjaga kesejahteraan psikologis.",
      },
      {
        title: "Kesadaran akan Pentingnya Perawatan Psikologis",
        description:
          "Meningkatkan kesadaran peserta tentang pentingnya perawatan psikologis dan bagaimana mengenali tanda-tanda gangguan mental.",
      },
      {
        title: "Pengembangan Keterampilan untuk Menjaga Kesehatan Mental",
        description:
          "Menyediakan keterampilan praktis yang dapat diterapkan dalam kehidupan sehari-hari untuk mengelola stres dan meningkatkan kesejahteraan mental.",
      },
      {
        title: "Pengembangan Kemampuan Coping",
        description:
          "Membantu peserta mengembangkan kemampuan coping yang efektif untuk menghadapi situasi sulit.",
      },
      {
        title: "Peningkatan Kualitas Hidup",
        description:
          "Meningkatkan kualitas hidup peserta dengan memberikan strategi untuk menjaga keseimbangan mental dan emosional.",
      },
      {
        title: "Pemberdayaan Diri",
        description:
          "Memberikan rasa percaya diri dan kemampuan untuk mengatasi tantangan psikologis dengan lebih baik.",
      },
    ],
  },
  {
    slug: "parenting-class",
    title: "Parenting Class",
    category: "Workshops",
    subtitle:
      "Kelas untuk membantu orang tua dalam mendukung perkembangan anak",
    description:
      "Layanan ini bertujuan untuk memberikan pengetahuan dan keterampilan kepada orang tua dalam mendukung perkembangan anak secara holistik. Program ini mencakup berbagai topik penting dalam pengasuhan, seperti komunikasi efektif, manajemen emosi, dan pengembangan karakter anak.",
    image: parentingImage,
    bgColor: "#C4B0FF",
    activity_description:
      "Program ini melibatkan berbagai sesi edukatif dan interaktif untuk meningkatkan kemampuan orang tua dalam mendukung perkembangan anak.",
    activity: [
      {
        title: "Komunikasi Efektif",
        description:
          "Mengajarkan teknik komunikasi yang efektif antara orang tua dan anak untuk memperkuat hubungan keluarga.",
        image: interviewImage,
        bgColor: "#9BE2D0",
      },
      {
        title: "Manajemen Emosi",
        description:
          "Memberikan panduan kepada orang tua tentang bagaimana mengelola emosi mereka sendiri dan membantu anak-anak mengelola emosi mereka.",
        image: konsultasiImage,
        bgColor: "#FFA2C9",
      },
      {
        title: "Pengembangan Karakter",
        description:
          "Pelatihan untuk mendukung pengembangan karakter positif pada anak, seperti disiplin, tanggung jawab, dan empati.",
        image: tesMinatBakatImage,
        bgColor: "#ECECEC",
      },
    ],
    benefit_image: talkPsikolog,
    benefits: [
      {
        title: "Peningkatan Kualitas Pengasuhan",
        description:
          "Meningkatkan kemampuan orang tua dalam mendukung perkembangan anak melalui pengasuhan yang positif dan efektif.",
      },
      {
        title: "Hubungan Keluarga yang Lebih Baik",
        description:
          "Memperkuat hubungan antara orang tua dan anak melalui komunikasi dan interaksi yang lebih baik.",
      },
      {
        title: "Peningkatan Kesejahteraan Emosional",
        description:
          "Membantu orang tua dan anak dalam mengelola emosi untuk menciptakan lingkungan keluarga yang harmonis.",
      },
      {
        title: "Dukungan dalam Pengembangan Anak",
        description:
          "Memberikan panduan untuk mendukung pengembangan karakter dan keterampilan sosial anak.",
      },
      {
        title: "Komunikasi yang Lebih Baik dengan Anak",
        description:
          "Mengajarkan orang tua teknik komunikasi yang efektif untuk memahami dan berhubungan lebih baik dengan anak.",
      },
      {
        title: "Peningkatan Kepercayaan Diri Orang Tua",
        description:
          "Meningkatkan kepercayaan diri orang tua dalam mengasuh dan mendidik anak mereka.",
      },
    ],
  },
  {
    slug: "recruitment-selection",
    title: "Recruitment & Selection",
    category: "Workshops",
    subtitle:
      "Bimbingan dan evaluasi untuk meningkatkan peluang diterima kerja",
    description:
      "Layanan ini bertujuan untuk membantu individu dalam mempersiapkan diri dan meningkatkan peluang diterima kerja melalui bimbingan psikologis, evaluasi, dan pelatihan yang tepat. Program ini mencakup penilaian keterampilan, simulasi wawancara, dan strategi untuk sukses dalam proses seleksi kerja.",
    image: recruitmentImage,
    bgColor: "#C4B0FF",
    activity_description:
      "Program ini melibatkan berbagai kegiatan untuk mempersiapkan dan memperkuat peluang individu dalam proses rekrutmen dan seleksi.",
    activity: [
      {
        title: "Penilaian Keterampilan dan Potensi",
        description:
          "Evaluasi menyeluruh terhadap keterampilan dan potensi individu untuk mengidentifikasi kekuatan yang dapat ditonjolkan dalam proses seleksi.",
        image: tesMinatBakatImage,
        bgColor: "#ECECEC",
      },
      {
        title: "Simulasi Wawancara",
        description:
          "Latihan simulasi wawancara untuk mempersiapkan diri menghadapi berbagai jenis wawancara kerja dengan lebih percaya diri.",
        image: interviewImage,
        bgColor: "#9BE2D0",
      },
      {
        title: "Pengembangan Strategi Seleksi",
        description:
          "Pelatihan untuk menyusun strategi sukses dalam menghadapi tes, wawancara, dan proses seleksi lainnya.",
        image: iqtestImage,
        bgColor: "#FFA2C9",
      },
    ],
    benefit_image: sharingClassImage,
    benefits: [
      {
        title: "Peningkatan Kepercayaan Diri",
        description:
          "Meningkatkan kepercayaan diri individu dalam menghadapi proses seleksi dan wawancara kerja.",
      },
      {
        title: "Identifikasi Kekuatan",
        description:
          "Membantu individu mengidentifikasi kekuatan dan potensi yang dapat ditonjolkan dalam proses rekrutmen.",
      },
      {
        title: "Persiapan Wawancara",
        description:
          "Memberikan persiapan yang komprehensif untuk menghadapi wawancara kerja dengan baik.",
      },
      {
        title: "Strategi Sukses",
        description:
          "Mengembangkan strategi personal yang efektif untuk meningkatkan peluang diterima kerja.",
      },
      {
        title: "Panduan Karir",
        description:
          "Memberikan panduan dan nasihat karir yang sesuai dengan keahlian dan tujuan individu.",
      },
      {
        title: "Dukungan Berkelanjutan",
        description:
          "Menyediakan dukungan berkelanjutan untuk individu selama proses pencarian kerja.",
      },
    ],
  },
  {
    slug: "sharing-class",
    title: "Sharing Class",
    category: "Workshops",
    subtitle: "Kelas berbagi pengetahuan dan pengalaman seputar psikologi",
    description:
      "Sharing Class adalah program di mana para peserta dapat berbagi pengetahuan dan pengalaman terkait psikologi dalam suasana yang interaktif dan edukatif. Kelas ini juga menjadi tempat untuk belajar dan berdiskusi tentang topik-topik terbaru dalam dunia psikologi.",
    image: sharingClassImage,
    bgColor: "#C4B0FF",
    activity_description:
      "Kelas ini melibatkan berbagai aktivitas berbagi pengetahuan dan diskusi tentang psikologi.",
    activity: [
      {
        title: "Diskusi Psikologi",
        description:
          "Berbagi pengetahuan dan pengalaman tentang berbagai topik psikologi.",
        image: tumbuhKembangImage,
        bgColor: "#9BE2D0",
      },
      {
        title: "Sesi Interaktif",
        description:
          "Kegiatan interaktif yang melibatkan peserta dalam pembelajaran aktif.",
        image: recruitmentImage,
        bgColor: "#7FDCF9",
      },
      {
        title: "Tanya Jawab",
        description:
          "Sesi tanya jawab untuk membahas isu-isu psikologi dan mendapatkan wawasan tambahan.",
        image: deteksiMasalahAkademikImage,
        bgColor: "#FFA2C9",
      },
    ],
    benefit_image: minatBakatImage,
    benefits: [
      {
        title: "Pengetahuan Mendalam",
        description:
          "Mendapatkan wawasan mendalam tentang topik-topik psikologi dari berbagai perspektif.",
      },
      {
        title: "Interaksi Sosial",
        description:
          "Kesempatan untuk berdiskusi dan berbagi pengalaman dengan peserta lainnya.",
      },
      {
        title: "Pembelajaran Aktif",
        description:
          "Terlibat dalam proses pembelajaran yang interaktif dan partisipatif.",
      },
      {
        title: "Wawasan Baru",
        description:
          "Memperoleh wawasan baru dari berbagai sudut pandang peserta lainnya.",
      },
      {
        title: "Pengembangan Diri",
        description:
          "Memfasilitasi perkembangan pribadi melalui pembelajaran dan refleksi bersama.",
      },
      {
        title: "Keterampilan Komunikasi",
        description:
          "Meningkatkan kemampuan berkomunikasi melalui diskusi dan interaksi dengan orang lain.",
      },
    ],
  },
];

export default layanans;
